/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'r-info': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g mask="url(#bg-mask-0)" fill-rule="evenodd" _fill="#df4545"><path pid="0" d="M10 7.5H6.25a.624.624 0 110-1.25H10a.624.624 0 110 1.25zm3.75 3.125h-7.5a.624.624 0 110-1.25h7.5a.624.624 0 110 1.25zm0 3.125h-7.5a.624.624 0 110-1.25h7.5a.624.624 0 110 1.25z"/><path pid="1" d="M15.17 18.75H4.83a3.583 3.583 0 01-3.58-3.58V4.83a3.583 3.583 0 013.58-3.58h10.342a3.585 3.585 0 013.58 3.58v10.34a3.586 3.586 0 01-3.582 3.58zM4.83 2.5A2.332 2.332 0 002.5 4.83v10.34a2.332 2.332 0 002.33 2.33h10.342a2.332 2.332 0 002.33-2.33V4.83a2.332 2.332 0 00-2.33-2.33H4.83z"/></g><defs><rect pid="2" id="path_0" x="0" y="0" width="20" height="20" rx="0" ry="0"/></defs>'
  }
})
